import React from 'react'

const LinkedIn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g>
        <g>
          <g>
            <path
              className="outer-path"
              fill="#939393"
              d="M15.5 31C24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0 6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31z"
            />
          </g>
          <g>
            <path
              fill="#f1f2f2"
              d="M7.22 23.337h3.726v-11.25H7.22zM7 8.617c0 1.081.808 1.947 2.054 1.947h.024c1.296 0 2.102-.866 2.102-1.947-.025-1.106-.806-1.947-2.077-1.947S7 7.511 7 8.617zm17.333 8.269c0-3.455-1.833-5.062-4.277-5.062-1.975 0-2.855 1.093-3.35 1.858v.037h-.024l.025-.037v-1.594H12.99c.05 1.055 0 11.248 0 11.248h3.716v-6.282c0-.337.026-.671.123-.912.27-.672.88-1.367 1.906-1.367 1.346 0 1.882 1.032 1.882 2.543v6.019h3.716z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default LinkedIn
